import React from 'react'

class FormCntl extends React.Component {
	constructor(){
		super()
this.state = {
			firstName: null,
			email:null,
			subject:null,
			message:null,
      condition: false,
      formErrors: {
        firstName: "",
        email: "",
        subject:"",
        message:""
      }
 		} 
		this.handler = this.handler.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		}
		 
		 handler(event){
       const {name, value, type, checked} = event.target;
       const emailExp = RegExp(/^([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/);
          //this.setState({[name]:value})
          let formErrors = this.state.formErrors;
          switch(name) {
case 'firstName':  formErrors.firstName = value.length < 3 && value.length > 0 
? "Please enter at least 4 chars" : "";
 console.log(formErrors.firstName)
   break;
   case 'email':  formErrors.email = emailExp.test(value)
? "" : "Please enter a valid email";
 console.log(formErrors.email)
   break;
   case 'subject':
      formErrors.subject = value.length < 8 && value.length > 0 ? "Please enter at least 8 chars of subject" : "";
      break;
      case 'message':
        formErrors.message = value.length < 15 && value.length > 0 ? "Please write something for us 15 character" : "";
        break;
   default:
     break;
    }
    this.setState({formErrors, [name]:value})
 		 }
		  handleSubmit(event) {
   
    event.preventDefault();
	this.setState({condition:true })
  }
  
  render() {
	return(
		 
		   <section id="contact" class="wow fadeInUp">
		 
		   
<div class="container card-box-c">
<div className={this.state.condition ? "overlay-frame" : "overlay-frame-off"}>
<h2>Your message has been sent. Thank you!</h2>
</div>
        <div class="form">
          <div id="sendmessage">Your message has been sent. Thank you!</div>
          <div id="errormessage"></div>
          <form action="" method="post" role="form" class="contactForm"  onSubmit={this.handleSubmit}>
            <div class="form-row">
              <div class="form-group col-md-6">
                <input required type="text" name="firstName" value={this.state.firstName} onChange={this.handler} class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                <div className="validation">
                {this.state.formErrors.firstName}
                </div>
              </div>
              <div class="form-group col-md-6">
                <input required type="email" value={this.state.email} onChange={this.handler} class="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
                <div className="validation">{this.state.formErrors.email}</div>
              </div>
            </div>
            <div class="form-group">
              <input required type="text" class="form-control" name="subject" type="subject" value={this.state.subject} onChange={this.handler} id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
              <div className="validation">{this.state.formErrors.subject}</div>
            </div>
            <div class="form-group">
              <textarea class="form-control" name="message" type="message" value={this.state.message} onChange={this.handler} rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
              <div className="validation">{this.state.formErrors.message}</div>
            </div>
            <div class="text-center"><button type="submit">Send Message</button></div>
          </form>
        </div>

      </div>
		 </section>
 )}
	}
 export default FormCntl